// extracted by mini-css-extract-plugin
export var button = "_c6-2";
export var iconWrapper = "_c6-0";
export var investigatingIcon = "_c6-1";